import React from 'react'
import { object } from 'prop-types'
import MetaTags from 'components/MetaTags'

import Layout from 'layouts/Layout'
import Section, { SectionBlock } from 'components/Section'
import Wrapper from 'components/Wrapper'
import { H1 } from 'styles/typography'
import RichText from 'components/RichText'

const ContentPage = ({ pageContext }) => (
  <Layout lightFooter>
    <MetaTags title={`${pageContext.title} - Vuse Canada`} />
    <Section>
      <Wrapper>
        <SectionBlock>
          <H1>{pageContext.title}</H1>
        </SectionBlock>
        <SectionBlock>
          <RichText>
            <div dangerouslySetInnerHTML={{ __html: pageContext.body }} />
          </RichText>
        </SectionBlock>
      </Wrapper>
    </Section>
  </Layout>
)

ContentPage.propTypes = {
  pageContext: object.isRequired
}

export default ContentPage
